import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import storeJs from 'store'
import configureStore from './store/configureStore'
import Loadable from './utils/Loadable'
import { PersistGate } from 'redux-persist/integration/react'
import './i18n'
import './styles-less/login.scss'
const PageLayout = Loadable('routers/PageLayout', true)
const { store, persistor} = configureStore()

function App () {
  useEffect(() => {
    let theme = 'light'
    const body = document.body
    theme = storeJs.get("theme")
    if(theme==='dark'){
      body.classList.add("dark")
      body.classList.remove("light")
    }
  }, [])

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <PageLayout />
      </PersistGate>
    </Provider>
  )
}

export default App
